import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { CUSTOM_SEVERITIES } from '../../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../../helpers/features';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import CustomRiskScoreBadge from '../../../generic/CustomRiskScoreBadge';
import DetailsPanel, { DetailsPanelList } from '../../../generic/DetailsPanel';
import DetailsPanelText from '../../../generic/DetailsPanel/DetailsPanelText';
import VulnerabilityDrawerSection from '../../../shared/vulns/Drawer/Section';
import type { VulnIssue } from '../../../../../shared/issuesV2';

const CustomRiskScoreDetails: VoidFunctionComponent = () => {
  const issueDetails = useSelector(IssuesV2Store.selectors.getIssueDetails);
  const isCustomSeveritiesEnabled = useIsFeatureEnabled(CUSTOM_SEVERITIES);

  if (!isCustomSeveritiesEnabled) {
    return null;
  }

  const customRiskScore = (issueDetails as VulnIssue)?.customRiskScore;

  if (!customRiskScore) {
    return null;
  }

  const reasonText = customRiskScore.reason || 'No reason given.';

  const rows = [
    {
      label: 'Assigned by',
      content: <span>{customRiskScore.createdBy || 'Unknown'}</span>,
    },
  ];

  return (
    <VulnerabilityDrawerSection>
      <DetailsPanel
        id="custom-risk-score-details"
        target="Custom risk score"
        targetButton={<CustomRiskScoreBadge score={customRiskScore.score} />}
    >
        <DetailsPanelText text={reasonText} />
        <DetailsPanelList rows={rows} />
      </DetailsPanel>
    </VulnerabilityDrawerSection>
  );
};

export default CustomRiskScoreDetails;
